module.exports = __webpack_public_path__ + "img/banner_04.f0190db.png";